<template>
  <div>
    <v-container fluid fill-height class="login">
      <!-- Gradient Layer on the Left -->
      <div class="gradient-left"></div>

      <v-row>
        <!-- Left Section (Gradient) -->
        <v-col cols="12" md="6" class="d-flex gradient-left-container">
          <!-- Empty, purely for gradient -->
        </v-col>

        <!-- Right Section (Login Form) -->
        <v-col cols="12" md="6" class="form d-flex justify-center align-center">
          <div class="content-form" style="max-width: 600px;">
            <form-login></form-login>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import formLogin from "./components/FormLogin";

export default {
  name: "LoginPage",
  components: {
    formLogin
  },
  data() {
    return {
      login: true
    };
  },
  methods: {
    setPage(val) {
      this.login = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  padding: 0;
  .logo {
    width: 150px;
    height: 50px;
    position: absolute;
    top: 20px;
    left: 20px;
  }
  .form {
    height: 100vh;
    display: flex;
    .content-form {
      width: 60%;
      margin: auto;
    }
  }
  .banner {
    height: 100vh;
    background-color: #f7ffff00;
    padding: 0;
    .slogan {
      position: absolute;
      left: 55vw;
      top: 15vh;
      color: white;
      p {
        font-size: 2vw;
        line-height: 40px;
      }
    }
    .img-login {
      display: flex;
      .background1 {
        position: absolute;
        width: 50vw;
        height: 30vh;
      }
      .img-illustration {
        width: 600px;
        margin: 10vh 7vw 0 7vw;
        z-index: 1;
      }
      .background2 {
        position: absolute;
        width: 50vw;
        height: 30vh;
        bottom: 0;
      }
    }
  }
  .bold {
    font-weight: bold;
  }
}

@media only screen and (max-width: 640px) {
  .form {
    height: 100vh;
    display: flex;
    .content-form {
      margin: auto;
    }
  }
  .banner {
    display: none;
  }
}
.login {
  position: relative;
  height: 100vh;
  display: flex;
}

.gradient-left {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 50%;
  background: linear-gradient(to top, #ef4036, #f7941d);
  z-index: 0;
}

.gradient-left-container {
  position: relative;
  z-index: 1; /* Ensures the layout remains correct */
}

.content-form {
  position: relative;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1;
}
@media only screen and (max-width: 640px) {
  .gradient-left {
    display: none;
  }
  .gradient-left-container {
    display: none;
  }
  .form {
    width: 100%;
  }
  .content-form {
    width: 90%; /* Menyesuaikan form agar sedikit lebih kecil dari lebar layar */
    margin: auto;
  }
}
</style>
